<template>
  <div id="stockOrdersPage">
    <vs-table
      id="branchDataList"
      ref="table"
      :data="stockOrderList"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <new-stock-order ref="newStockOrder" @reload="getList" />
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col v-if="!$isCenterBranch() && isNewOrderPermission" vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni Sipariş" position="top">
                    <vs-button
                      @click="addNewData"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" vs-w="w-auto">
                  <vx-tooltip text="Listeyi Yenile" position="top">
                    <vs-button
                      @click="getList"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-refresh-ccw"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" vs-w="w-auto">
                  <vx-tooltip title="Excel Export"
                  position="top">
                  <vs-button @click="getExcel" color="transparent" type="gradient"
                  class="panel-action text-warning xlarge-button panel-action-box-shadow" icon-pack="feather" icon="icon-download" />
                </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" vs-w="w-auto">
                  <vx-tooltip title="Kırılımlı Excel Export"
                  position="top">
                  <vs-button @click="getExcelWithDetail" color="transparent" type="gradient"
                  class="panel-action text-warning xlarge-button panel-action-box-shadow" icon-pack="feather" icon="icon-download" />
                </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-2/12">
          <span class="text-primary text-smaller bold"> Id </span>
        </vs-th>
        <vs-th class="w-3/12">
          <vs-button
            class="p-1 weight-600 text-smaller border-none"
            icon-pack="feather"
            line-position="top"
            :icon="
              tableOptions.sortBy == 'branch.Name' ? sortingHeadIcon : null
            "
            color="primary"
            type="line"
            @click="setSortingOptions('branch.Name')"
            >Şube
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <span class="text-primary text-smaller bold"> Kalem </span>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600 text-smaller border-none"
            icon-pack="feather"
            line-position="top"
            :icon="tableOptions.sortBy == 'Created' ? sortingHeadIcon : null"
            color="primary"
            type="line"
            @click="setSortingOptions('Created')"
            >Tarih
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600 text-smaller border-none"
            icon-pack="feather"
            line-position="top"
            color="primary"
            type="line"
            >Saat
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <span class="text-primary text-smaller bold"> Durum </span>
        </vs-th>
        <vs-th class="w-2/12">
          <span class="text-primary text-smaller bold"> Tutar </span>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody style="text-align: center">
          <vs-tr
            :class="{
              'border-green': getViewState($isCenterBranch(), stockOrder),
            }"
            :data="stockOrder"
            :key="index"
            v-for="(stockOrder, index) in data"
          >
            <vs-td class="w-2/12">
              <span class="text-dark weight-600 text-smaller">
                {{ stockOrder.orderId }}
              </span>
            </vs-td>

            <vs-td class="w-3/12">
              <span class="text-dark weight-600 text-smaller">
                {{ stockOrder.branch.name }}
              </span>
            </vs-td>

            <vs-td class="w-1/12">
              <span class="text-dark weight-600 text-smaller">
                {{ stockOrder.totalEntryCount }}
              </span>
            </vs-td>

            <vs-td class="w-2/12">
              <span class="text-dark pointer weight-600 text-smaller">
                <vx-tooltip
                  color="primary"
                  title="Geçen Süre"
                  :text="stockOrder.passedDay"
                  position="top"
                >
                  {{ stockOrder.date }}
                </vx-tooltip>
              </span>
            </vs-td>
            <vs-td class="w-2/12">
              <span class="text-dark pointer weight-600 text-smaller">
                <vx-tooltip
                  color="primary"
                  title="Geçen Süre"
                  :text="stockOrder.passedDay"
                  position="top"
                >
                  {{ stockOrder.time }}
                </vx-tooltip>
              </span>
            </vs-td>
            <vs-td class="w-2/12">
              <div
                v-if="stockOrder.status == 2"
                class="w-full d-flex justify-center"
              >
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="h-4 w-4 text-success"
                />
                <span class="text-success bold italic text-smaller text-center">
                  {{ stockOrder.completeDate }}
                </span>
              </div>
              <span
                v-else
                class="bold italic text-smaller text-center"
                :class="$getOrderStatusColor(stockOrder.status)"
              >
                {{ $getOrderStatus(stockOrder.status) }}
              </span>
            </vs-td>
            <vs-td class="w-2/12">
              <span class="text-dark pointer weight-600 text-smaller">
                <vx-tooltip
                  color="primary"
                  position="top"
                >
                  {{ $toCurrency(stockOrder.totalPrice) }}
                </vx-tooltip>
              </span>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>
<script>
import moduleStockOrder from "@/store/stockOrder/moduleStockOrder.js";
import PaginationDefault from "../PaginationDefault";
import GlobalFilter from "../GlobalFilter";
import NewStockOrder from "./NewStockOrder.vue";
import {isGranted} from "@/utils/auth";
import {
  getStockOrderList,
  getEmptyStockOrder,
  getOrderEntries,
  getStockOrderListForDealer,
  getStockOrderExcel,
  getStockOrderExcelWithDetail,
  getStockOrderExcelForDealer,
  getStockOrderExcelWithDetailForDealer
} from "@/api/StockOrder.js";
/* eslint-disable */
export default {
  data() {
    return {
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,
      tableOptions: {},
      emptyStockOrder: {},
      selected: null,
      filterOptions: [
        "branchCode",
        "branch",
        "stockOrder",
        "rawMaterial",
        "variant",
        "stockCode",
        "dateRange",
        "stockOrderStatus",
        "dateRangeComplete",
      ],
      filterOptionNames: [
        "Şube Kodu",
        "Şube",
        "Sipariş",
        "Hammadde",
        "Varyant",
        "Stok Kodu",
        "Oluş. Tarihi",
        "Durum",
        "Tam. Tarihi",
      ],
      filterChips: [],
      isFilterActive: false,
    };
  },
  props: ["orderId"],
  components: {
    NewStockOrder,
    PaginationDefault,
    GlobalFilter,
  },
  methods: {
    getExcel() {
      if(this.$isRegionalCenterBranch()){
        getStockOrderExcelForDealer(this.tableOptions).then(res => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'siparisler.xlsx');
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
      }else{
        getStockOrderExcel(this.tableOptions).then(res => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'siparisler.xlsx');
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
      }
      
      },
      getExcelWithDetail() {
      if(this.$isRegionalCenterBranch()){
        getStockOrderExcelWithDetailForDealer(this.tableOptions).then(res => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'siparisler.xlsx');
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
      }else{
        getStockOrderExcelWithDetail(this.tableOptions).then(res => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'siparisler.xlsx');
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
      }
      
      },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.currentPage = 0;
      filterOptions.pageIndex = this.currentPage;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branch: this.$isCenterBranch() || this.$isRegionalCenterBranch() ? null : this.$currentUser.branch,
        stockOrderStatus: null,
        stockOrder: null,
        branchCode: null,
        rawMaterial: null,
        stockCode: null,
        variant: null,
        dateRange: {
          startDate: null, //this.$now.date().toString(),
          endDate: null, //this.$now.date().toString(),
        },
        dateRangeComplete: {
          startDate: null, //this.$now.date().toString(),
          endDate: null, //this.$now.date().toString(),
        },
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    getViewState: function (centerBranch, stockOrder) {
      if (stockOrder.viewState) {
        if (centerBranch) {
          if (stockOrder.status === "Await") return true;
          else return false;
        } else {
          if (stockOrder.status !== "Await") return true;
          else return false;
        }
      } else return false;
    },
    reviewStockOrder: async function (stockOrder) {
      getOrderEntries(stockOrder.id)
        .then((res) => {
          if (res && res.status == 200) {
            this.$refs.newStockOrder.stockOrder = _.cloneDeep(stockOrder);
            this.$refs.newStockOrder.stockOrder.groupes = res.data;
            this.$refs.newStockOrder.isPreview = true;
            this.$refs.newStockOrder.isActive = true;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Sipariş Detayı Getirlemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    addNewData: async function () {
      if (Object.keys(this.emptyStockOrder).length == 0)
        this.emptyStockOrder = await getEmptyStockOrder();
      this.$refs.newStockOrder.stockOrder = _.cloneDeep(this.emptyStockOrder);
      this.$refs.newStockOrder.isActive = true;
      this.$refs.newStockOrder.isPreview = false;
    },
    getList: async function () {
      if (this.$isRegionalCenterBranch()) {
        this.stockOrderList = await getStockOrderListForDealer(this.tableOptions);
      }else{
        this.stockOrderList = await getStockOrderList(this.tableOptions);
      }
      
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  mounted() {
    if (this.$route.params.orderId) {
      let orderId = this.$route.params.orderId;
      this.tableOptions.stockOrder = { id: orderId };
    }
  },
  computed: {
    isNewOrderPermission(){
      return isGranted("stock_order_create")
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
    stockOrderList: {
      get() {
        return this.$store.getters["stockOrder/getStockOrderList"];
      },
      set(val) {
        this.$store.dispatch("stockOrder/setStockOrderList", val);
      },
    },
    totalDataRow() {
      return this.$store.state.stockOrder.totalDataRow;
    },
  },
  created: async function () {
    if (!moduleStockOrder.isRegistered) {
      this.$store.registerModule("stockOrder", moduleStockOrder);
      moduleStockOrder.isRegistered = true;
      this.clearFilter();
    }
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getList();
        });
      },
    },
    selected(val) {
      if (val && val.id) {
        this.reviewStockOrder(val);
        this.selected = null;
      }
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
};
</script>

<style>
#stockOrderRow:hover {
  -webkit-transform: translateY(-4px);
  transform: translateY(-4px);
}

#stockOrderRow {
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  cursor: pointer;
}

.border-green {
  border: 1px solid green;
}
</style>
